import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import FormRenderer from './components/FormRenderer';
import { RUNTIME_CONFIG } from './config/runtime';
import * as Sentry from '@sentry/react';


//const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_BASE_URL = RUNTIME_CONFIG.apiEndpoint;

const App = () => {
  const [searchParams] = useSearchParams();

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [formSubmissionLoading, setFormSubmissionLoading] = useState(false);

  const [formJson, setFormJson] = useState(null);
  const serviceId = searchParams.get('serviceId');
  const formId = searchParams.get('formId');
  const apiKey = searchParams.get('apiKey');

  useEffect(() => {
    const getJSON = async () => {
      if (!serviceId || !formId) {
        console.error('Missing serviceId or formId in URL.');
        return;
      }
      try {
        // Reset Stuff
        setShowSuccess(false);
        setShowError(false);
        setFormSubmissionLoading(false);

        // Get Form JSON
        const response = await fetch(`${API_BASE_URL}/api/v1/service/${serviceId}/form/${formId}`);
        if (!response.ok) {
          Sentry.captureReactException(response, 'Failed to fetch form');
          throw new Error(`Failed to fetch form: ${response.statusText}`);
        }
        const data = await response.json();

        if (data?.data?.errorHtml) {
          setErrorMessage(data.data.errorHtml);
        }

        if (data?.data?.successHtml) {
          setSuccessMessage(data.data.successHtml);
        }
        if (data?.data) {
          setFormJson(data.data);
        }

      } catch (error) {
          // Sentry.captureReactException(error, 'Failed to fetch form');
      }
    };

    getJSON();
  }, [serviceId, formId]);

  const handleFormSubmit = async (formData) => {
    setFormSubmissionLoading(true);
    try {
      const queryParams = new URLSearchParams(formData).toString();

      const response = await fetch(
        `${API_BASE_URL}/api/v1/contact/service/${serviceId}?api-key=${apiKey}&audienceid=${formJson.audienceId}&timezone=${formJson.contactDetailTimeZone}&${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        Sentry.captureReactException(response, 'Failed to submit form');
        throw new Error('Failed to submit form');
      }

      // eslint-disable-next-line no-unused-vars
      const result = await response.json();
      // alert('Form submitted successfully!');
      setShowSuccess(true);
      setShowError(false);
      setFormSubmissionLoading(false);
    } catch (error) {
      // alert('Failed to submit form. Please try again.');
      setShowSuccess(false);
      setShowError(true);
      setFormSubmissionLoading(false);
    }
  };

  if (showError) {
    return (
      <div style={{ width: "100%", height: "100%" }} dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
    );
  }
  if (showSuccess) {
    return (
      <div style={{ width: "100%", height: "100%" }} dangerouslySetInnerHTML={{ __html: successMessage }}></div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>    
      {formJson ? (
        <FormRenderer formJson={formJson} onSubmit={handleFormSubmit} formSubmissionLoading={formSubmissionLoading} />
      ) : (
        <p>Loading....</p>
      )}
    </div>
  );
};

export default App;